import { Box } from '@mui/material';
import { createMRTColumnHelper } from 'material-react-table';
import React from 'react';

import CummonTable from '../../Common/CummonTable';

const AgentList = ({ data }) => {
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor('company', {
      header: 'Company',
    }),

    columnHelper.accessor('phone', {
      header: 'Phone',
      size: '10px',
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
  ];

  return (
    <div>
      <Box
        sx={{
          boxSizing: 'border-box',
        }}
      >
        <CummonTable data={data} columns={columns} pageSize={5} />
      </Box>
    </div>
  );
};

export default AgentList;
